'use strict';

import { LICENSE_CONSTANTS } from './LicenseConstants';

const SIGNATURE_HTML_CONTENT_MAX_SIZE = 64 * 1024;
const SIGNATURE_PLACEHOLDER = '$Signature$';

//ATTENTION: MOA veut:
// - TemplatePage : ne pas montrer popup pour SCV2 et SM2
// - Sequence V1, V2 et engagement par mail: montre SCV2 et SM2
const LICENSES_SHOWING_SIGNATURE_POPUP_WHEN_NO_SIGNATURE = [
  LICENSE_CONSTANTS.SALES.ID,
  LICENSE_CONSTANTS.MARKETING.ID,
  LICENSE_CONSTANTS.SALES_AND_MARKETING.ID,
  LICENSE_CONSTANTS.SALES_PME.ID,
  LICENSE_CONSTANTS.SALES_AUTOMATION.ID,
  LICENSE_CONSTANTS.SALES_AUTOMATION_V2.ID,
  LICENSE_CONSTANTS.SMART_CAMPAIGN_V2.ID,
  LICENSE_CONSTANTS.SALES_AND_MARKETING_V2.ID,
];

const LICENSES_SHOWING_SIGNATURE_POPUP_IN_MULTICHANNEL_SEQUENCE = [
  LICENSE_CONSTANTS.SALES_AUTOMATION_V2.ID,
  LICENSE_CONSTANTS.SMART_CAMPAIGN_V2.ID,
  LICENSE_CONSTANTS.SALES_AND_MARKETING.ID,
  LICENSE_CONSTANTS.SALES_AND_MARKETING_V2.ID,
];

export {
  LICENSES_SHOWING_SIGNATURE_POPUP_IN_MULTICHANNEL_SEQUENCE,
  LICENSES_SHOWING_SIGNATURE_POPUP_WHEN_NO_SIGNATURE,
  SIGNATURE_HTML_CONTENT_MAX_SIZE,
  SIGNATURE_PLACEHOLDER,
};
